import { lazy } from "preact-iso"

// A view whose module loads on first render — Suspense-style, so a prerender
// waits for it and the Router keeps the previous view up meanwhile. Takes the
// loaders autoexport's LazyFunctionImporter compiles: `LazyView(Views.viewer)`.
export const LazyView = lazy
